<template>
  <div class="chartsHeight">
    <van-row type="flex" justify="space-between" align="center" class="chartsTitle">
      <van-col span="12">
        <div class='nameWrap' >{{name}}</div>
      </van-col>
      <van-col span="12" class="buttonChange timeButton">
        <button :class="{ choose:1===time }" @click="changeTime(1)" v-show="showFlag && showFlag.indexDay">日</button>
        <button :class="{ choose:2===time }" @click="changeTime(2)" v-show="showFlag && showFlag.indexMonth">月</button>
        <button :class="{ choose:3===time }" @click="changeTime(3)" v-show="showFlag && showFlag.indexYear">年</button>
      </van-col>
    </van-row>
    <van-row id="iframeWidth" :style="{height: iframeHeight}">
      <div style="padding: 0;margin: 0">
          <form method="POST" id="formChart" style="display: none;" target="iframeChart">
            <input name="resid" type="text" value="">
            <input name="showtoolbar" type="text" value="false">
            <input name="paramsInfoBase64" type="text" value="">
          </form>
        <div :style="{height: iframeHeight}" id="iframeChartDiv">
            <iframe id="iframeChart" name="iframeChart" style="width: 100%;height: 100%" frameborder="0" scrolling="no"></iframe>
          </div>
        </div>
    </van-row>
    <van-row
      class="buttonChange buttonBottom"
      type="flex"
      justify="center"
      :style="{padding: '15px 0px'}"
    >
      <van-col span="6">
        <button :class="{ choose:1===shape }" @click="changeShape(1)">柱状图</button>
      </van-col>
      <van-col span="6">
        <button :class="{ choose:2===shape }" @click="changeShape(2)">折线图</button>
      </van-col>
      <van-col span="6">
        <button :class="{ choose:3===shape }" @click="changeShape(3)">表格</button>
      </van-col>
    </van-row>
  </div>

</template>

<script>
import {ifrSrc} from '@/utils/smartbi/dataComponent'
import {getSmartbiLeadFlag} from '@/utils/request'
import {getAction} from '@/utils/api'
import {promiseIsBatchFinish} from '@/utils/util'

export default {
  name: 'SmartbiChart',
  data () {
    return {
      time: 2, // 默认显示时间维度为月
      shape: 1, // 默认显示为柱状图
      // iframeSrc: '',
      unit: '',
      name: '',
      iframeHeight: '',
      showFlag: null, // 显示年月日的判断,
      rlen: history.length
    }
  },
  methods: {
    // 点击年月日
    changeTime (val) {
      this.time = val
      var that = this
      new Promise(promiseIsBatchFinish).then(function () {
        that.getIframe()
      })
    },
    // 点击柱状图、折线图、表格
    changeShape (val) {
      this.shape = val
      var that = this
      new Promise(promiseIsBatchFinish).then(function () {
        that.getIframe()
      })
    },
    // 接口请求，获取指标的单位、是否有年、月、日、产品分析（险类维度、主附维度、短期健康险/非健康险）、结构分析、银行渠道分析、是否有达成率、口径（标准、考核）
    getQuotaDetailRe () {
      this.name = this.$store.state.entirety.quotaName
      var getPostdata = {
        moduleId: this.$store.state.user.pageCode, // 模块id
        indexId: this.$store.state.entirety.quota, // 指标id
        channelId: this.$store.state.entirety.channel // 渠道id
      }
      var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
      getFlag.then(res => {
        let resData = res.data
        this.showFlag = resData
        this.unit = resData.unit
        this.$store.commit('SMARTBI_HEADUNIT', resData.title)
        this.$store.commit('SMARTBI_UNIT', this.unit) // 单位（元、人、%）
        this.$store.commit('SMARTBI_HAS_BANK', resData.hasBank) // 是否有银行渠道分析
        this.$store.commit('SMARTBI_HAS_MAIN_RISK', resData.hasMainRisk) // 是否有主附维度
        this.$store.commit('SMARTBI_HAS_RISK_HUMAN', resData.hasRiskHuman) // 是否有险类维度
        this.$store.commit('SMARTBI_HAS_RISK_HELTH', resData.hasRiskHelth) // 是否有短期健康险/非健康险
        this.$store.commit('SMARTBI_HAS_PROJECT', resData.hasProject) // 是否有产品分析
        this.$store.commit('SMARTBI_HAS_REGULAR', resData.hasRegular) // 转正维度
        this.$store.commit('SMARTBI_HAS_STRU', resData.hasStru) // 是否有结构分析
        this.$store.commit('SMARTBI_HAS_STRU_WORKYREAR', resData.hasStruWorkyear) // 司龄
        this.$store.commit('SMARTBI_INDEX_DAY', resData.indexDay) // 是否有日
        this.$store.commit('SMARTBI_INDEX_MONTH', resData.indexMonth) // 是否有月
        this.$store.commit('SMARTBI_INDEX_YEAR', resData.indexYear) // 是否有年
        this.$store.commit('SMARTBI_REAL_TIME', resData.realTime) // 是否实时指标(0:离线指标，1：实时指标)
        this.$store.commit('SMARTBI_CAL', resData.cal) // 口径（0：标准口径、1：考核口径）
        this.$store.commit('SMARTBI_HAS_ACHIEVEMENT_RATE', resData.hasAchievementRate) // 是否有达成率(0:没有 1：有)
        this.$store.commit('SMARTBI_IS_PRE_ENTRY', resData.isPreEntry)
        this.$store.commit('SMARTBI_START_TIME', resData.startTime)
        this.time = 2
        this.shape = 1
        // 当指标没有月统计时，默认显示年的数据统计
        if (!resData.indexMonth) {
          this.time = 3
        }
        // 率值类指标默认显示折线图
        if (this.unit === '%') {
          this.shape = 2
        }
        var that = this
        // promiseIsBatchFinish为当发送报表请求前查询数据库实时数据是否跑完，若实时数据没有跑完，所有查询时间往前推一天
        new Promise(promiseIsBatchFinish).then(function () {
          that.getIframe()
        })
      })
    },
    getIframe () {
      var areaFlag = this.$store.state.user.areaFlag
      var areaCode = this.$store.state.user.areaCode
      var channelCode = this.$store.state.entirety.channel
      var orgId = this.$store.state.user.orgId
      var level = this.$store.state.user.level
      var quota = this.$store.state.entirety.quota
      var headIno = this.$store.state.smartbi.headUnit
      var moduleCode = this.$store.state.user.pageCode
      // 达成率、年同比，需作为参数传到报表，报表根据值判断是否显示年同比和达成率
      var hasAchievementRate = 0
      var hasNtb = 0
      // 选择年且不是导入指标时
      if (this.time === 3 && this.$store.state.entirety.classification !== 5) {
        hasAchievementRate = this.$store.state.smartbi.hasAchievementRate
        hasNtb = 1
      }
      var resid = ''
      switch (this.shape) {
        case 1:
          resid = ifrSrc.columnResid
          break
        case 2:
          resid = ifrSrc.lineResid
          break
        case 3:
          resid = ifrSrc.tableResid
          break
        default:
          resid = ifrSrc.columnResid
      }
      var unitParam = {
        'name': 'headUnit',
        'value': "'" + this.unit + "'"
      }
      var headInoParam = {
        'name': 'headIno',
        'value': headIno
      }
      var isAssementRateParam = {
        'name': 'isAssementRate',
        'value': hasAchievementRate + ''
      }
      var isAcompareWithRateParam = {
        'name': 'isAcompareWithRate',
        'value': hasNtb + ''
      }
      var timepram = {
        'name': 'dateType',
        'value': this.time + ''
      }
      var trendJsonParam = {
        'areaFlag': areaFlag + '',
        'areaCode': areaCode,
        'moduleCode': moduleCode,
        'channel': channelCode,
        'indexCode': quota,
        'orgId': orgId,
        'level': level,
        'dateType': this.time + '',
        'isChart': this.shape + ''
      }
      var pramJson = {
        'name': 'trendJson',
        'value': trendJsonParam
      }
      var leadFlagpram = {
        leadFlag: getSmartbiLeadFlag()
      }
      var headerpram = {
        'name': 'header',
        'value': JSON.stringify(leadFlagpram)
      }
      var paramsInfo = []
      paramsInfo.push(unitParam)
      paramsInfo.push(headInoParam)
      paramsInfo.push(isAssementRateParam)
      paramsInfo.push(isAcompareWithRateParam)
      paramsInfo.push(timepram)
      paramsInfo.push(pramJson)
      paramsInfo.push(headerpram)
      var param = JSON.stringify(paramsInfo)
      var that = this
      let form = document.getElementById('formChart')
      form.resid.value = resid
      form.paramsInfoBase64.value = btoa(unescape(encodeURIComponent(param)))
      // 防止多次加载iframe，返回上一级没有返回到主页面的上一页，先移除iframe，再添加
      if (document.getElementById('iframeChart')) {
        document.getElementById('iframeChart').remove()
      }
      document.getElementById('iframeChartDiv').innerHTML = '<iframe id="iframeChart" name="iframeChart" style="width: 100%;height: 100%" frameborder="0" scrolling="no"></iframe>'
      var url = ifrSrc.smartbiUrl
      if (that.shape === 3) {
        url = ifrSrc.smartbiUrlTable
      }
      form.action = url
      form.submit()
    }
  },
  computed: {
    getQuota () {
      return this.$store.state.entirety.quota
    },
    getChannel () {
      return this.$store.state.entirety.channel
    }

  },
  watch: {
    // 指标切换
    getQuota () {
      this.$nextTick(() => {
        this.getQuotaDetailRe()
      })
    },
    // 渠道切换
    getChannel () {
      this.$nextTick(() => {
        document.getElementById('chartIframeDiv')
        this.getQuotaDetailRe()
      })
    }
  },
  mounted () {
    // 各个手机适配：报表宽度平铺。351/509为报表原始高度/宽度
    var width = document.documentElement.clientWidth
    var height = 351 / 509 * width
    this.iframeHeight = height + 'px'
    if (this.$store.state.entirety.type !== '' && this.$store.state.entirety.type !== undefined) {
      this.getQuotaDetailRe()
    }
  }
}
</script>

<style scoped>
  .chartsHeight {
    margin-top: 0.1rem;
    height: 100%;
    background: #fff;
  }
  .chartsTitle {
    font-size: 0.18rem;
    font-weight: 600;
    height: 0.45rem;
    line-height: 0.45rem;
    padding: 0px 15px;
  }
  .numTitle {
    font-size: 0.12rem;
    margin-bottom: 0.15rem;
    padding-left: 0.15rem;
  }
  span {
    display: inline-block;
    width: 0.35rem;
    height: 1px;
    border: 1px solid #3399FF;
    vertical-align: middle;
    margin-right: 5px;
  }
  .buttonChange {
    font-size: 0;
    text-align: right;
  }
  .buttonChange button {
    height: 0.26rem;
    line-height: 0.26rem;
    border: none;
    margin: 0;
    font-size: 0;
    font-size: 0.14rem;
    padding: 0 15px;
    color: #39f;
    background: none;
    border: 1px solid #39f;
    border-radius: 0.02rem;
  }
  .timeButton button {
    border: 1px solid #F2F2F2;
    color: #999;
  }
  .buttonChange .choose {
    background: #3399FF;
    border: 1px solid #3399FF;
    color: #fff;
    border-radius: 0.02rem;
  }
  .buttonBottom {
    text-align: center;
    position: relative;
    z-index: 999;
  }
  table {
    width: 100%;
  }
  table td, table th {
    font-size: 0.14rem;
    padding: 10px 0;
    text-align: center;
  }
  table thead {
    color: #333;
    background: #fafafc;
  }
  .table > tbody > tr > td {
    border-top: none;
  }
  .table > thead > tr > th {
    border-bottom: none;
  }
  #divScroll{
    overflow: hidden;
  }
  .nameWrap{
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    line-height: 0.2rem;
    min-width: 160px;
    white-space:nowrap;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/SmartbiChart.vue